import React, { useState } from 'react';
import './List.css';
import '../App.css';
import { Button, Snackbar, Divider, useMediaQuery } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor } from '../GlobalState';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import './List.css';
import { changeUserPasswords } from '../apicalls/getPasswords';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

export const ChangePassword: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF'
      },
      input: {
        borderColor: '#c1c1c1',
        borderWidth: 1,
        width: '70%',
        borderRadius: 3
      },
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      }
    })
  );

  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [openSuccess, setOpenSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const matches2 = useMediaQuery('(min-width:900px)');

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const classes = useStyles();

  const changeYourPassword = () => {
    if (
      password1.trim() === '' ||
      password2.trim() === '' ||
      currentPassword.trim() === ''
    ) {
      setOpen(true);
      setErrorMessage('すべてのフィールドは必須です。');
    } else if (password1.trim() !== password2.trim()) {
      setOpen(true);
      setErrorMessage('新しいパスワードと確認用パスワードが一致しません。');
    } else {
      changeUserPasswords(currentPassword, password1, password2).then(data => {
        if (typeof data === 'string') {
          setOpen(true);
          setErrorMessage(data);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
          }
        }
      });
    }
  };

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='change_password' />

      <>
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error'>
            {errorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSuccess}
          autoHideDuration={4000}
          onClose={handleCloseSuccess}
        >
          <Alert onClose={handleClose} severity='success'>
            {successMessage}
          </Alert>
        </Snackbar>
      </>
      <div
        style={{
          backgroundColor: '#F5F5F5',
          paddingTop: 100,
          paddingRight: !matches2 ? 30 : 250,
          paddingLeft: !matches2 ? 30 : 250,
          minHeight: window.innerHeight - 150
        }}
      >
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <div
          style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
        >
          <div className='table-top-container-customer'>
            <div style={{ fontWeight: 'bold' }}>パスワード変更</div>
          </div>
          <div>
            <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
            <div className={classes.subContainer}>
              <div className={classes.textMainContainer}>
                <div className={classes.textContainer}>現在のパスワード</div>
              </div>
              <div className={classes.inputMainContainer}>
                <div className={classes.inputContainer}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className={classes.input}
                    onChange={text => {
                      setCurrentPassword(text.target.value);
                    }}
                  />
                  {showPassword ? (
                    <VisibilityOffIcon
                      style={{ color: '#6c757d', marginLeft: 15 }}
                      onClick={() => setShowPassword(false)}
                    />
                  ) : (
                    <VisibilityIcon
                      style={{ color: '#6c757d', marginLeft: 15 }}
                      onClick={() => setShowPassword(true)}
                    />
                  )}
                </div>
              </div>
            </div>

            <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
            <div className={classes.subContainer}>
              <div className={classes.textMainContainer}>
                <div className={classes.textContainer}>新しいパスワード</div>
              </div>
              <div className={classes.inputMainContainer}>
                <div className={classes.inputContainer}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className={classes.input}
                    onChange={text => {
                      setPassword1(text.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
            <div className={classes.subContainer}>
              <div className={classes.textMainContainer}>
                <div className={classes.textContainer}>
                  新しいパスワード（確認用）
                </div>
              </div>
              <div className={classes.inputMainContainer}>
                <div className={classes.inputContainer}>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className={classes.input}
                    onChange={text => {
                      setPassword2(text.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              flex: 1,
              textAlign: 'center'
            }}
          >
            <Button
              onClick={() => {
                changeYourPassword();
              }}
              style={{
                marginTop: 20,
                paddingLeft: 50,
                paddingRight: 50,
                backgroundColor: buttonColor
              }}
              variant='contained'
              color='primary'
            >
              変更
            </Button>
          </div>
        </div>
      </div>

      <FooterComponent />
    </div>
  );
};
